import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { REPORT_GROUPS_QUERY_KEY } from './useInfiniteReportGroups';
import { ReportGroup } from '@/api/generatedApi';

export const useCreateReportGroup = ({
  reportId,
  onSuccess,
  onError,
}: {
  reportId: string;
  onSuccess?: (group: ReportGroup) => void;
  onError?: (error: string) => void;
}) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { mutate, isPending } = useMutation({
    mutationFn: async ({ name }: { name?: string }) => {
      const response = await api.reports.createReportGroup(tenantId, reportId, { name });
      return response.data.group;
    },
    onSuccess: group => {
      queryClient.invalidateQueries({ queryKey: [REPORT_GROUPS_QUERY_KEY] });
      onSuccess?.(group);
    },
    onError: (error: Error) => {
      onError?.(error.message || 'Failed to create group');
    },
  });

  return {
    mutate,
    isPending,
  };
};
